<bx-button-group selectionMode="multiple" [selectedIds]="selectedIds()" (selectionChange)="handleSelectionChange($event)">
  <button bx-button-group-item [id]="viewAllId">{{ 'product-view.property-overview.viewAll' | translate }}</button>

  @for (product of products; track product.id) {
    <button bx-button-group-item [id]="product.id">{{ product.label }}</button>
  }
</bx-button-group>
